import type { User, UserProfile } from '@/common/user.common'
import { onSessionReset } from '@/api/sessionScope'
import { LOCAL_STORAGE_KEY } from '@/providers/auth/AuthContext'
import { create } from 'zustand'

interface UserStore {
  user: User | null
  profile: UserProfile | null
  loading: boolean
  sessionRestored: boolean
  setLoading: (loading: boolean) => void
  setUser: (user: User | null) => void
  setProfile: (profile: UserProfile | null) => void
  setSessionRestored: (value: boolean) => void
}

const useUserStore = create<UserStore>(set => ({
  user: null,
  profile: null,
  loading: true,
  sessionRestored: false,
  setLoading: (loading: boolean) => set({ loading }),
  setUser: (user: User | null) => {
    if (user) {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(user))
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEY)
    }
    set({ user })
  },
  setProfile: (profile: UserProfile | null) => set({ profile }),
  setSessionRestored: (v: boolean) => set({ sessionRestored: v }),
}))

// SIB-924: the identity itself is session-scoped. On any session reset
// (logout, new login, failed refresh) the previous user and profile are
// dropped — a new login sets its own user right afterwards, and on expiry
// the route guards then redirect to the login page.
onSessionReset(() => {
  useUserStore.getState().setUser(null)
  useUserStore.getState().setProfile(null)
})

export { useUserStore }
